"use client"
import useSWRImmutable from 'swr/immutable'

const fetcher = (url: string) => fetch(url).then((r) => r.json())

export default function useAirports(airport: string | undefined) {
    
  const { data, error, mutate, isLoading, isValidating } = useSWRImmutable(
     airport ? `/api/airports?airport=${airport}` : `/api/airports`,
    //`/api/airports`,
    fetcher
  )

  return {
    data: data?.data,
    mutate,
    isLoading: isLoading,
    isValidating: isValidating,
    isError: error,
  }
}